import styled from 'styled-components';

// Medidas do protótipo: barra cinza com grupos de ferramentas e o preenchimento à direita; texto
// numa folha (serifa, entrelinha larga, justificado); campos em amarelo com ✓/✗.
export const Container = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;

  .decl-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 6px 8px;
    border-bottom: 1px solid #dee2e6;
    background: #f8f9fa;
    flex-wrap: wrap;
  }

  .decl-tools {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-wrap: wrap;

    button {
      width: 32px;
      height: 32px;
      border: 0;
      border-radius: 4px;
      background: transparent;
      color: #495057;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover:not(:disabled),
      &.active {
        background: #e9ecef;
      }

      &:disabled {
        opacity: 0.4;
      }

      &.tool-gap {
        margin-left: 10px;
      }

      .material-icons-outlined {
        font-size: 20px;
      }
    }
  }

  .decl-fill-actions {
    display: flex;
    gap: 8px;

    button {
      min-height: 32px;
      border: 1px solid;
      border-radius: 4px;
      padding: 3px 10px;
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 13px;
      background: #fff;

      .material-icons-outlined {
        font-size: 17px;
      }

      &:disabled {
        opacity: 0.5;
      }
    }

    .fill-accept {
      border-color: #28a745;
      color: #1e7e34;

      &:hover:not(:disabled) {
        background: #d4edda;
      }
    }

    .fill-reject {
      border-color: #dc3545;
      color: #dc3545;

      &:hover {
        background: #f8d7da;
      }
    }
  }

  .decl-page-wrap {
    max-height: 360px;
    overflow: auto;
    background: #fff;
  }

  .decl-page {
    min-height: 180px;
    padding: 24px 32px;
    font-family: Merriweather, Georgia, 'Times New Roman', serif;
    font-size: 14px;
    line-height: 1.9;
    color: #212529;
    outline: none;

    &:focus-visible {
      box-shadow: inset 0 0 0 2px #80bdff;
    }

    p {
      margin-bottom: 14px;
    }
  }

  .campo {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    border-radius: 2px;
    padding: 0 3px;
    font-weight: 700;
    white-space: normal;
  }

  .campo-sugerido,
  .campo-recusado,
  .campo-pendente {
    background: #ffe9a6;
  }

  .campo-recusado .campo-valor,
  .campo-pendente .campo-valor {
    outline: 1px dashed #d39e00;
    padding: 0 3px;
    cursor: text;
  }

  .campo-aceito {
    background: transparent;
  }

  .campo-acao {
    width: 20px;
    height: 18px;
    border: 1px solid;
    border-radius: 2px;
    background: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding: 0;
    cursor: pointer;

    .material-icons-outlined {
      font-size: 14px;
    }

    &[data-act='ok'] {
      border-color: #28a745;
      color: #28a745;
    }

    &[data-act='no'] {
      border-color: #dc3545;
      color: #dc3545;
    }
  }

  .campo-input {
    font-size: inherit;
    border: 1px solid #80bdff;
    border-radius: 3px;
    padding: 0 4px;
    min-width: 140px;
  }

  .read-only .decl-page {
    background: #fff;
  }
`;
